$(function() {
	if ((!$body.hasClass('page-template-page-rooms') && !$body.hasClass('page-template-page-club-access') && !$body.hasClass('page-template-page-ada-rooms')))
		return;

	$('.call_to_action').mouseenter(function(){
		$(this).parent().parent().addClass('white');
	}).mouseleave(function(){
		$(this).parent().parent().removeClass('white');
	});

	var sliders = $('.rooms .slides');
	var loadedCount = 0;
	var rooms = $('.room');

	sliders.each(function() {
		initializeSlick(this, {
			accessibility: true,
			dots: false,
			infinite: true,
			speed: 700,
			slidesToShow: 1,
			arrows: true,
			fade: true,
			nextArrow: '<button class="slider_arrow next_arrow white">Next</button>',
			prevArrow: '<button class="slider_arrow prev_arrow white">Previous</button>',
			focusOnSelect: true,
		}, function() {
			loadedCount += 1;
			if (loadedCount == sliders.length) {
				slidersBuilt();
			}
		});
	});

	var club_access_sliders = $('.club_access .slides');
	var loadedCount = 0;

	club_access_sliders.each(function() {
		initializeSlick(this, {
			accessibility: true,
			dots: false,
			infinite: true,
			speed: 700,
			slidesToShow: 1,
			arrows: true,
			fade: true,
			nextArrow: '<button class="slider_arrow next_arrow white">Next</button>',
			prevArrow: '<button class="slider_arrow prev_arrow white">Previous</button>',
			focusOnSelect: true,
		});
	});

	function roomsFilter() {
		var myul = $('.myul');
		var lis = myul.find('li');
		var dropdown = $('.show');
		var lower = $('.lower');
		lis.on('click', function(e) {
			dropdown.toggleClass('flip');
			if (myul.hasClass('active')) {
				myul.removeClass('active');
			}
			else {
				myul.addClass('active');
			}
			lis.removeClass('active');
			$(e.target).parent().addClass('active');
		});
	}

	function slidersBuilt() {
		$window.trigger('resize');
		var categories = $('.category_link');
		var activeCategory = 'resort';
		var rooms = $('.room');
		var filteredRooms = rooms;

		$(window).on('hashchange', function(e){
			var currentUrl = URI(document.location);
			var hash = currentUrl.hash();
			
			// Don't interfere with booking widget routing
			// Check for both #/booking and /booking to be safe
			if (hash && (hash.indexOf('/booking') === 0 || hash.indexOf('#/booking') === 0)) {
				return;
			}
			
			if (hash) {
				var currentlySelected = categories.filter('[href="' + hash + '"]');
				if (currentlySelected.length) {
					currentlySelected.trigger('click')
				} else {
					categories.eq(0).trigger('click');
				}
			} else {
				categories.eq(0).trigger('click');
			}
		});


		$('#filter_mobile_button').click(function(){
			$('#rooms_categories nav').toggleClass('open');
		});

		var updateUrl = function(url) {
			if (url != window.location.href)
				window.history.pushState('', '', url);
			// update active link in main nav
			$('#main_menu').find('a[href="' + url + '"]').parent().siblings().removeClass('current-menu-item');
			$('#main_menu').find('a[href="' + url + '"]').parent().addClass('current-menu-item');
		}

		var filterCategory = function(element) {
			rooms.removeClass('appear even odd');
			if (element) {
				element = $(element);
				activeCategory = element.attr('href').slice(1);
			}

			rooms.hide();
			if (activeCategory == 'all') {
				filteredRooms = rooms;
			} else {
				filteredRooms = rooms.filter('[cat*=' + activeCategory + ']');
			}

			if(activeCategory === "club-lounge"){
				$('.secondary-booking').show();
				$('.main-booking').hide();
			} else {
				$('.secondary-booking').hide();
				$('.main-booking').show();
			}

			displayRooms(filteredRooms);

			updateUrl(document.location.origin + document.location.pathname + '#' + activeCategory);
		}

		var displayRooms = function(filteredRooms) {
			filteredRooms.each(function(i) {
				if (i%2 == 0 || i == 0) {
					$(this).addClass('even');
				} else {
					$(this).addClass('odd');
				}
			});
			filteredRooms.show();
			setTimeout(function() {
				filteredRooms.addClass('appear');
				filteredRooms.find('.slides').slick('refresh');
			}, 50);
		}

		
		setInterval(function() {
			$window.trigger('resize');
		}, 500);

		categories.click(function() {
			categories.removeClass('active_category');
			$(this).addClass('active_category');
			filterCategory(this);
		});
		
		var currentUrl = URI(document.location);
		var hash = currentUrl.hash();

		// Don't interfere with booking widget routing on page load
		if (hash && (hash.indexOf('/booking') === 0 || hash.indexOf('#/booking') === 0)) {
			// Do nothing - let the third-party booking widget handle it
		} else if (hash) {
			var currentlySelected = categories.filter('[href="' + hash + '"]');
			if (currentlySelected.length) {
				currentlySelected.trigger('click')
			} else {
				categories.eq(0).trigger('click');
			}
		} else {
			categories.eq(0).trigger('click');
		}

		if (!categories.length)
			displayRooms(rooms);


		// Activate the proper category and imageon page load
		var currentUrl = URI(document.location);
		if (currentUrl.hash()) {
			// Don't interfere with booking widget routing
			if (currentUrl.hash().indexOf('/booking/') !== 0) {
				var currentlySelected = categories.filter('[href="' + currentUrl.hash() + '"]');
				if (currentlySelected.length) {
					currentlySelected.trigger('click')
				} else {
					categories.eq(0).trigger('click');
				}
			}
		} else {
			categories.eq(0).trigger('click');
		}
	}

	rooms.find('.button').click(function(e) {
		e.stopPropagation();
	});
	roomsFilter();
});